import { createSelector } from 'reselect';
import { getUsersState } from 'src/modules/users/selectors/getUsersState';

export const getUserEditing = createSelector([
  getUsersState,
], (state) => state.editing);
